export default "__VITE_ASSET__BJjfbMlP__"